import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetTiktokPostsData } from '../../Models/ITiktokPost';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { TiktokCommentDto, ITiktokComment } from '../../Models/ITiktokComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { TiktokService } from '../../Services/tiktok.service';
import { ITiktokPolitician } from '../../Models/ITiktokPolitician';

@Component({
  selector: 'app-tiktok-post-details',
  templateUrl: './tiktok-post-details.component.html',
  styleUrls: ['./tiktok-post-details.component.scss']
})
export class TiktokPostDetailsComponent implements OnInit {
  @Input() postId?: string;
  postDetails: IGetTiktokPostsData | null = null;
  attackedPoliticianDetails: ITiktokPolitician | null = null;
  isLoading = false;
  error: string = '';

  //icons
  faExternalLink = faExternalLink;

  constructor(
    private drawerRef: NzDrawerRef<TiktokPostDetailsComponent>,
    private tiktokService: TiktokService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId) {
      this.loadPostDetails();
    } else {
      this.error = 'No post ID provided';
    }
  }

    
  loadPostDetails(): void {
    this.isLoading = true;
    this.error = '';
    
    this.tiktokService.getPostDetails(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response: IGetTiktokPostsData) => {
          console.log('Post details received:', response);
          this.postDetails = response;
          
          // Check if postDetails has the required properties
          if (!this.postDetails || typeof this.postDetails !== 'object') {
            this.error = 'Invalid response format received';
          }
        },
        error: (error) => {
          this.error = 'Failed to load post details. Please try again.';
        }
      });
  }


  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

  close(): void {
    this.drawerRef.close();
  }
}